import { BellRing } from 'lucide-react';
import { Button } from '@/components/ui';
import { useEntityFollow } from './entityFollow';

/**
 * A brand page's "Active offers" when none is running (web plan W0.10):
 * "No active offers right now — follow {Brand} for alerts", in place of an
 * empty (or missing) section, with the page's own follow button beside it.
 * The button is the header's action and state (useEntityFollow), so the two
 * never disagree; outside a detail layout only the sentence is shown.
 */
export function NoActiveOffers({ brandName, className }: { brandName: string; className?: string }) {
  const follow = useEntityFollow();
  return (
    <div
      className={`flex flex-wrap items-center gap-3 rounded-2xl border border-line bg-card p-4 ${className ?? ''}`}
    >
      <BellRing size={20} className="shrink-0 text-primary" aria-hidden="true" />
      <p className="min-w-0 flex-1 basis-48 font-semibold text-ink">
        No active offers right now — follow {brandName} for alerts
      </p>
      {follow && (
        <Button
          size="sm"
          variant={follow.subscribed ? 'outline' : 'primary'}
          loading={follow.subscribing}
          onClick={follow.toggleFollow}
        >
          {follow.subscribed ? `Following ${brandName}` : `Follow ${brandName}`}
        </Button>
      )}
    </div>
  );
}

export default NoActiveOffers;
